import { render, staticRenderFns } from "./ProspectsReports.vue?vue&type=template&id=e77fc758&"
import script from "./ProspectsReports.vue?vue&type=script&lang=js&"
export * from "./ProspectsReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports